import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import Icon from '@material-ui/core/Icon';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { DEMOCRATIC_COLOR, REPUBLICAN_COLOR } from '../../common/Utils';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import fallback_image from './../../images/member-fallback.svg'

const useStyles = makeStyles(
	{
		root: {
			width: '100%',
			height: 150,
			boxShadow: 'none'
		},
		content: {
			textAlign: 'center',
			paddingLeft: 0,
			paddingRight: 0
		},
		imageIcon: {
    		height: '40%'
  		},
  		iconRoot: {
			textAlign: 'center'
		},
		titleText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 15,
			fontWeight: 500,
			letterSpacing: 0,
		},
		valueText: {
			color: '#333',
			fontFamily: 'Graphik',
			fontSize: 16,
			fontWeight: 600,
			letterSpacing: 0,
			marginTop: 5,
		}
	}
);

function getColorFilter(partyColor) {

	switch (partyColor) {
		case DEMOCRATIC_COLOR:
			return {filter: "invert(24%) sepia(44%) saturate(5248%) hue-rotate(211deg) brightness(105%) contrast(88%)"};
		case REPUBLICAN_COLOR:
			return {filter: "invert(9%) sepia(90%) saturate(6457%) hue-rotate(8deg) brightness(99%) contrast(116%)"};
		default:
			return {filter: "invert(50%) sepia(94%) saturate(334%) hue-rotate(84deg) brightness(90%) contrast(91%)"};
	}
}

const FALLBACK_IMAGE = fallback_image;

function onMediaFallback(event) {
	event.target.src = FALLBACK_IMAGE;
	event.target.style.opacity = '0';
}

const StackedImageCard = ( { imageURL, imageColor, title, value } ) => {
	const classes = useStyles();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.up('sm'));

	return (
		<Card className={classes.root}>
			<Icon classes={{root: classes.iconRoot}}>
				  <img
					alt={title}
					className={classes.imageIcon}
					src={imageURL}
					onError={onMediaFallback}
					style={getColorFilter(imageColor)}
				  />
			</Icon>
			<CardContent className={classes.content}>
				<Typography className={classes.titleText}
				style={(matches)?{fontSize: 15}:{fontSize: 12}}>
					{title}
				</Typography>
				<Typography className={classes.valueText} style={(matches) ? {fontSize: 16} : {fontSize: 12}}>
					{value}
				</Typography>
        	</CardContent>
		</Card>
	)
}

StackedImageCard.propTypes = {
  imageURL: PropTypes.string.isRequired,
  imageColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

export default StackedImageCard;
